export var config = {
  getRecommendationServiceUrl: function getRecommendationServiceUrl(baseUrl) {
    return baseUrl ? "".concat(baseUrl, "/gateway/api/v1/recommendations") : '/gateway/api/v1/recommendations';
  },
  getUsersServiceUrl: function getUsersServiceUrl(productKey) {
    var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return productKey === 'jira' ? "".concat(baseUrl, "/rest/api/3/user/bulk") : "".concat(baseUrl, "/wiki/rest/api/user/bulk");
  },
  getGraphQLUrl: function getGraphQLUrl(baseUrl) {
    return baseUrl ? "".concat(baseUrl, "/gateway/api/graphql") : "/gateway/api/graphql";
  },
  getTeamsUrl: function getTeamsUrl(baseUrl) {
    return baseUrl ? "".concat(baseUrl, "/gateway/api/v3/teams") : "/gateway/api/v3/teams";
  }
};